import { getSkillDescription, getSkillName } from "../i18n/gameContent"
import type { MessageId, MessageValues } from "../i18n/messages"
import { SKILL_MAP } from "../match/engine/content/skills"
import type { SkillSelection } from "../schemas"

type TranslateFn = (id: MessageId, values?: MessageValues) => string

export function getSkillModifierLabels(
  t: TranslateFn,
  selection: SkillSelection,
) {
  const labels: string[] = []
  const definition = SKILL_MAP.get(selection.skillId)

  if (selection.mode === "non_exhausting") {
    labels.push(t("cardFace.skill.nonExhausting"))
  } else if (selection.mode === "self_destruct") {
    labels.push(t("cardFace.skill.overload"))
  } else if (definition?.isPassive === false) {
    labels.push(t("cardFace.skill.exhaust"))
  }

  if (selection.allyRequirement === 1) {
    labels.push(t("cardFace.skill.ally.one"))
  } else if (selection.allyRequirement === 2) {
    labels.push(t("cardFace.skill.ally.two"))
  }

  return labels
}

export function getSkillTooltip(t: TranslateFn, selection: SkillSelection) {
  const parts = [
    getSkillName(t, selection.skillId),
    getSkillDescription(t, selection.skillId),
  ]
  const modifiers = getSkillModifierLabels(t, selection)
  if (modifiers.length > 0) {
    parts.push(modifiers.join(" • "))
  }
  return parts.join("\n")
}
